export const environment = {
  production: true,
  prodUrl: "https://oddsee.azurewebsites.net/",
  devUrl: "https://oddsee-test.azurewebsites.net/",
};

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
